import * as actionTypes from "./OmniChannelsTypes";

const INTIAL_STATE = {
  data: null,
  loading_state: false,
  omniData: null,

  loading_email: false,
  emailData: null,
  get_loading_email: false,
};
const OmniChannelsReducer = (state = INTIAL_STATE, action) => {
  const { payload } = action;
  switch (action.type) {
    case actionTypes.IS_LOADING_WHATSAPP:
      return {
        ...state,
        loading_state: true
      };
    case actionTypes.WHATS_APP_SUCCESS:
      return {
        ...state,
        data: payload,
        loading_state: false
      };
    case actionTypes.WHATS_APP_FALED:
      return {
        ...state,
        loading_state: false
      };
    ////////////////////////////////////////////////
    case actionTypes.OMNI_SUCCESS:
      return {
        ...state,
        omniData: payload,
      };
    case actionTypes.OMNI_FALED:
      return {
        ...state,
        omniData: null,
      };
    //////////////////////////////////////////////////////
    case actionTypes.IS_LOADING_EMAIL:
      return {
        ...state,
        loading_email: true
      };
    case actionTypes.EMAIL_SUCCESS:
      return {
        ...state,
        emailData: payload,
        loading_email: false
      };
    case actionTypes.EMAIL_FALED:
      return {
        ...state,
        loading_email: false
      };
    ////////////////////////////////////////////////

    case actionTypes.IS_LOADING_GET_EMAIL:
      return {
        ...state,
        get_loading_email: true
      };
    case actionTypes.GET_EMAIL_SUCCESS:
      return {
        ...state,
        emailData: payload,
        get_loading_email: false
      };
    case actionTypes.GET_EMAIL_FALED:
      return {
        ...state,
        get_loading_email: false
      };
    ////////////////////////////////////////////////

    default:
      return state;
  }
};

export default OmniChannelsReducer;
